module.exports = __webpack_public_path__ + "static/media/cherry-blossom-icon.1db4ab2c.png";